import { render, staticRenderFns } from "./PersonalTrainerForm.vue?vue&type=template&id=55380857&"
import script from "./PersonalTrainerForm.vue?vue&type=script&lang=js&"
export * from "./PersonalTrainerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports